import axios from "axios";

const resolveApiBaseUrl = () => {
    if (process.env.REACT_APP_API_BASE_URL) return process.env.REACT_APP_API_BASE_URL;
    if (process.env.NODE_ENV === "development") return "http://localhost:8081/api";

    if (typeof window !== "undefined") {
        const hostname = window.location.hostname;
        if (hostname === "localhost" || hostname === "127.0.0.1") {
            return "http://localhost:8081/api";
        }
    }

    return "/api";
};

const API_BASE_URL = axios.create({
    baseURL: resolveApiBaseUrl(),
    timeout: 15000,
});


API_BASE_URL.interceptors.request.use(
    (config) => {
        try {
            const token = localStorage.getItem("token");
            if (token) {
                config.headers = config.headers || {};
                config.headers.Authorization = `Bearer ${token}`;
            }
        } catch (e) {
            console.error("Erreur récupération token", e);
        }
        return config;
    },
    (error) => Promise.reject(error)
);

API_BASE_URL.interceptors.response.use(
    (response) => response,
    (error) => {

        const status = error && error.response ? error.response.status : null;
        const isOnLogin = window.location.pathname === "/login";

        if (!error.response) {
            console.warn("API inaccessible ou requete annulee");
            return Promise.reject(error);
        }

        const serverMessage = error.response.data?.message || error.response.data?.error;
        if (serverMessage) {
            error.message = serverMessage;
        }

        if (status === 401) {
            const currentToken = localStorage.getItem("token");
            const requestAuthorization = error.config?.headers?.Authorization;
            const isLoginRequest = /\/auth\/login(?:\?|$)/.test(error.config?.url || "");
            // A delayed response from a previous session must not sign out the current user.
            if (isLoginRequest || !currentToken || requestAuthorization !== `Bearer ${currentToken}`) {
                return Promise.reject(error);
            }
            console.warn("401 Unauthorized reçu → suppression du token et redirection vers /login");
            localStorage.removeItem("token");
            localStorage.removeItem("userConnectedData");
            window.dispatchEvent(new Event("soma-session-expired"));
            if (!isOnLogin) {
                window.location.replace("/login");
            }
            return Promise.reject(error);
        }

        if (status === 403) {
            console.warn("403 Forbidden reçu — possible rôle manquant ou token invalide");
        }

        return Promise.reject(error);
    }
);

export default API_BASE_URL;
